
import { Prop, Vue, Watch } from "vue-property-decorator";
import StatusWindow from "./status-window";

export default class Tirscript3ModalWindow extends Vue {
  @Prop({ default: "title" }) title: string;
  @Prop({ default: "", type: String }) icon: string;
  @Prop({ default: "", type: String }) iconImg: string;
  @Prop({ default: false, type: Boolean }) visible: boolean;
  @Prop({ default: true, type: Boolean }) showCloseBtn: boolean;
  // @Prop({ default: "300px", type: String })           width: string;
  @Prop({ default: StatusWindow.Text, type: Number }) type: StatusWindow;

  @Prop({ default: false, type: Boolean }) noButton: boolean;
  @Prop({ default: true, type: Boolean }) showHeaderTitle: boolean;
  @Prop({ default: true, type: Boolean }) autoClose: boolean;
  @Prop({ default: false }) closeIfClickOutside: boolean;
  @Prop({ default: { ok: "Ok", cancel: "Cancel" }, type: Object })
  textButtonDefault: { ok: string; cancel: string };

  innerVisible: boolean = false;
  elementClick: any = null;

  @Watch("visible")
  onChangeVisible() {
    this.innerVisible = this.visible;
  }
  // @Watch("innerVisible")
  // onChangeVisible(visible: boolean) {
  //   this.innerVisible = visible;
  // }
  created() {
    this.innerVisible = this.visible;
  }
  hasSlotData() {
    return this.$slots.button;
  }
  closeWindow() {
    this.innerVisible = false;
    this.$emit("close");
    return false;
  }
  onCancel() {
    this.$emit("cancel");
    this.closeWindow();
    return false;
  }
  onOk() {
    this.$emit("ok");
    return false;
  }
  onKeyDown(evt: any) {
    if (this.innerVisible) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.onCancel();
      }
    }
  }
  getWindowsType(type: StatusWindow) {
    var value = "";
    switch (type) {
      case 1:
        //text
        value = "";
        break;
      case 2:
        //error
        value = "icon-icon_error";
        break;
      case 3:
        //warning
        value = "icon-icon_warning";
        break;
      case 4:
        //info
        value = "icon-icon_info";
        break;
      default:
        break;
    }

    return value;
  }
  mouseDownWrapper(ev: MouseEvent) {
    this.elementClick = ev.target;
  }
  mouseUpWrapper(ev: MouseEvent) {
    const wrapper = document.getElementById("modal-wrapper");
    if (this.elementClick == wrapper && ev.target == wrapper) {
      if (this.closeIfClickOutside) {
        this.innerVisible = false;
      }
      this.$emit("clickOutside");
    }
  }
  show() {
    this.innerVisible = true;
  }
  hide() {
    this.innerVisible = false;
  }
}
